<div class="">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{title || 'Confirm'}}</h4>
      <button type="button" class="close" (click)="close()" *ngIf="hideClose !== undefined && !hideClose || hideClose === undefined" >&times;</button>
    </div>
    <div class="modal-body">
      <p class="body_content">{{message || 'Are you sure?'}}</p>
      <p class="body_content" *ngIf="additionalMessage">{{additionalMessage}}</p>
    </div>
    <div class="modal-footer" style="text-align:right">
      <button type="button" class="btn cancel_btn width100 float-left" (click)="close()" *ngIf="hideClose !== undefined && !hideClose || hideClose === undefined">Cancel</button>
      <button type="button" data-testid="ok_btn" class="btn action_btn width100" (click)="confirm()">{{okBtnMsg||'OK'}}</button>
    </div>
  </div>
</div>
